<div class="modal-title">
    <p class="no-margin">{{ modalComponent()?.title() }}</p>
    @if (modalComponent()?.isDismissable()) {
        <ui-icon-button iconName="cancel" size="small" (click)="close.emit(undefined)" />
    }
</div>

<div
    class="modal-content"
    [backgroundColor]="modalComponent()?.background?.color || DEFAULT_BG_COLOR"
    [backgroundColorDerivation]="modalComponent()?.background?.derivation"
>
    <ng-container #modalHost />
</div>

@if (buttons().length) {
    <div
        class="advizeo-toolbar toolbar-right"
        [backgroundColor]="modalComponent()?.background?.color || DEFAULT_BG_COLOR"
        [backgroundColorDerivation]="modalComponent()?.background?.derivation"
    >
        @for (button of buttons(); track $index) {
            <button
                type="button"
                ui-button
                class="no-margin"
                [attr.savee-modal-button]="button.anchor"
                [trackClick]="button.trackClick"
                [color]="button.color"
                [disabled]="button.isDisabled ?? false"
                [buttonStyle]="button.buttonStyle ?? 'fill'"
                [pending]="button.isPending ? button.isPending : false"
                [iconName]="button.iconName"
                (click)="button.onClick()"
            >
                {{ button.text | translate }}
            </button>
        }
    </div>
}
